<div class="w-full flex flex-col gap-y-[100px]">
  <app-header></app-header>

  <main class="private-container">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>